import { AiOutlineInstagram } from 'react-icons/ai';
// import { AiOutlineTwitter } from 'react-icons/ai';
// import { BiLogoFacebook } from 'react-icons/bi';
import pastor from '../Assets/images/IMGM7445.JPG';
import pastor1 from '../Assets/images/IMGM7444.JPG';
import pastor2 from '../Assets/images/IMGM7452.JPG';
export const PastorData = [
    {
        ServicesDescription: 'Legal Representative and general superintendent',
        servicesIcon: pastor2,
        Ista:<AiOutlineInstagram />,
        // Twit: <AiOutlineTwitter />,
        // Face: <BiLogoFacebook />,
        Services: 'Rev. Jean paul NSEKANABO',
        Phone: '+250789687372',
        IstaLink:'https://www.instagram.com/paulnsekanabojean?igsh=MTh3azM0ODI0emF3bg==',
        // TwitLink: '',
        // FaceLink: '',
    },
    {
        ServicesDescription: 'Assistant Legal Representative',
        servicesIcon: pastor,
        Ista:<AiOutlineInstagram />,
        // Twit: <AiOutlineTwitter />,
        // Face: <BiLogoFacebook />,
        Services: 'Rev. Silas Rwenyaguza Rugimbana',
        Phone: '+250788592296',
        IstaLink:'https://www.instagram.com/rwenyaguza_rugimbana_silas?igsh=amVwemk1ZGRpMmNy&utm_source=qr',
        // TwitLink: '',
        // FaceLink: '',
    },
    {
        ServicesDescription: 'Assistant General superintendent',
        servicesIcon: pastor1,
        Ista:<AiOutlineInstagram />,
        // Twit: <AiOutlineTwitter />,
        // Face: <BiLogoFacebook />,
        Services: 'Rev. Dieudone CYUNGURA',
        Phone: '+250788844385',
        IstaLink:'https://www.instagram.com/cyungura_dieudonne?igsh=MTJkbmVkaWdrNTU0Yw==',
        // TwitLink: '',
        // FaceLink: '',
    }
    
]
